export const toTeamOption = (team) => ({
  label: `${team.city} ${team.name}`,
  value: team.TeamID,
});

export const toSeasonOption = (season) => ({
  label: `${season.season}`,
  value: season.SeasonID,
});

export const toLeagueOption = (league) => ({
  label: `${league.name}`,
  value: league.LeagueID,
});

export const toPlayerOption = (player) => ({
  label: `${player.firstName} ${player.lastName}`,
  value: player.PlayerID,
});

export const toGameOption = (game) => ({
  label: `${game.date} - ${game?.HomeTeamDetails?.city} vs ${game.AwayTeamDetails?.city} (${game.gameType})`,
  value: game.GameID,
});
